// extracted by mini-css-extract-plugin
export default {"noDataDiv":"EmptyScreen_noDataDiv__LFADe","noData-Img":"EmptyScreen_noData-Img__Y0kxr","noData-text":"EmptyScreen_noData-text__-ig8n"};